/* Optimum Fusion: delivery pin on the cart page.
   Customer drops a pin on a map (anywhere, not just where they are now). Saved as a Google Maps link in the order. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'Location pin';
  var pinned = false, wantCheckout = false;
  var GKEY = 'AIzaSyD5I_7PREPgqtvNCWnfHyiMBDOHAiy0QK0';
  function onCart() { return location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, ''); }
  if (!onCart()) return;
  var root_el = document.documentElement;
  root_el.classList.add('of-pin-wait');
  setTimeout(function () { root_el.classList.remove('of-pin-wait'); }, 3500);

  var css = document.createElement('style');
  css.textContent =
    '.of-pin-wait [name="checkout"]{opacity:0!important;pointer-events:none!important;}' +
    '.of-pin{margin:0 0 14px;padding:12px;border:1px solid rgba(62,166,183,.6);border-radius:12px;background:rgba(62,166,183,.12);display:grid;gap:8px;text-align:center;}' +
    '.of-pin--need{border-color:#e0a030;background:rgba(224,160,48,.12);}' +
    '.of-pin__title{font-weight:700;font-size:14px;margin:0;}' +
    '.of-pin__hint{font-size:12px;opacity:.85;margin:0;line-height:1.4;}' +
    '.of-pin__btn{display:block;width:100%;padding:12px;border:2px solid #3ea6b7;border-radius:999px;background:transparent;color:#3ea6b7;font-weight:700;font-size:15px;cursor:pointer;}' +
    '.of-pin__btn--fill{background:#3ea6b7;color:#fff;}' +
    '.of-pin__btn[disabled]{opacity:.6;cursor:default;}' +
    '.of-pin__ok{font-weight:700;font-size:14px;color:#3ea6b7;margin:0;}' +
    '.of-pin__ok a{color:inherit;text-decoration:underline;margin-left:6px;}' +
    '.of-map{position:fixed;inset:0;z-index:2147483200;background:rgba(4,46,58,.7);display:flex;align-items:flex-end;justify-content:center;padding:12px;}' +
    '@media (min-width:700px){.of-map{align-items:center;}}' +
    '.of-map__box{width:100%;max-width:520px;max-height:96vh;overflow:auto;background:#fff;color:#042e3a;border-radius:16px;padding:14px;display:grid;gap:10px;}' +
    '.of-map__head{display:flex;justify-content:space-between;align-items:center;font-weight:700;font-size:16px;}' +
    '.of-map__x{border:0;background:transparent;font-size:24px;line-height:1;cursor:pointer;color:#042e3a;padding:0 4px;}' +
    '.of-map__search{display:flex;gap:6px;}' +
    '.of-map__search input{flex:1;min-width:0;padding:10px 12px;border:1px solid rgba(62,166,183,.6);border-radius:10px;font-size:15px;color:#042e3a;background:#fff;}' +
    '.of-map__search button{padding:0 14px;border:0;border-radius:10px;background:#3ea6b7;color:#fff;font-weight:700;cursor:pointer;}' +
    '.of-map__canvas{height:48vh;min-height:260px;border-radius:12px;overflow:hidden;background:#dfe9ea;}' +
    '.of-map__tip{font-size:12px;margin:0;opacity:.8;}' +
    '.of-map__err{font-size:12px;color:#c33;margin:0;}' +
    '.of-map__btn{display:block;width:100%;padding:12px;border:2px solid #3ea6b7;border-radius:999px;background:#fff;color:#3ea6b7;font-weight:700;font-size:15px;cursor:pointer;}' +
    '.of-map__btn--fill{background:#3ea6b7;color:#fff;}' +
    '.of-map__btn[disabled]{opacity:.5;cursor:default;}' +
    '.of-map .of-pin-icon{font-size:34px;line-height:34px;text-align:center;filter:drop-shadow(0 2px 2px rgba(0,0,0,.4));}';
  document.head.appendChild(css);

  var gLoading = false, gQueue = [];
  function loadMaps(cb) {
    if (window.google && google.maps && google.maps.Map) return cb();
    gQueue.push(cb);
    if (gLoading) return;
    gLoading = true;
    window.__ofMapsReady = function () { var q = gQueue.slice(); gQueue = []; q.forEach(function (f) { f(); }); };
    window.gm_authFailure = function () { var q = gQueue.slice(); gQueue = []; q.forEach(function (f) { f(new Error('auth')); }); var e = document.querySelector('.of-map [data-err]'); if (e) { e.textContent = 'The map could not load. Please try again later.'; e.hidden = false; } };
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + GKEY + '&callback=__ofMapsReady&loading=async&v=weekly';
    s.async = true;
    s.onerror = function () { gLoading = false; var q = gQueue.slice(); gQueue = []; q.forEach(function (f) { f(new Error('net')); }); };
    document.head.appendChild(s);
  }

  function save(url) {
    var a = {}; a[KEY] = url;
    var line = 'Delivery location: ' + url;
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var keep = String(c.note || '').split('\n').filter(function (l) { return l.indexOf('Delivery location:') !== 0; }).join('\n').trim();
        var note = keep ? keep + '\n' + line : line;
        return fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: a, note: note })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('save'); return r.json(); });
  }
  function urlFor(lat, lng) { return 'https://www.google.com/maps?q=' + lat.toFixed(6) + ',' + lng.toFixed(6); }
  function parse(url) {
    var m = /q=(-?\d+\.?\d*),(-?\d+\.?\d*)/.exec(url || '');
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
  }

  function openMap(startUrl, done) {
    var modal = document.createElement('div');
    modal.className = 'of-map';
    modal.innerHTML =
      '<div class="of-map__box" role="dialog" aria-modal="true">' +
        '<div class="of-map__head"><span>&#128205; Choose your delivery location</span><button type="button" class="of-map__x" data-x aria-label="Close">&times;</button></div>' +
        '<div class="of-map__search"><input type="search" placeholder="Search area, mall or building" data-q><button type="button" data-go>Search</button></div>' +
        '<div class="of-map__canvas" data-canvas></div>' +
        '<p class="of-map__tip">Tap the map or drag the pin to the exact spot where you want the delivery (home, villa, building). Use the Satellite button for a clearer view.</p>' +
        '<p class="of-map__err" data-err hidden></p>' +
        '<button type="button" class="of-map__btn" data-me>Use my current location</button>' +
        '<button type="button" class="of-map__btn of-map__btn--fill" data-ok disabled>Confirm this location</button>' +
      '</div>';
    document.body.appendChild(modal);
    document.documentElement.style.overflow = 'hidden';
    var err = modal.querySelector('[data-err]');
    function close() { if (modal.parentNode) modal.parentNode.removeChild(modal); document.documentElement.style.overflow = ''; }
    modal.querySelector('[data-x]').addEventListener('click', function () { wantCheckout = false; close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) { wantCheckout = false; close(); } });

    loadMaps(function (e) {
      if (e || !window.google || !google.maps) { err.textContent = 'The map could not load. Please check your connection and try again.'; err.hidden = false; return; }
      var start = parse(startUrl);
      var center = start ? { lat: start[0], lng: start[1] } : { lat: 24.4539, lng: 54.3773 };
      var map = new google.maps.Map(modal.querySelector('[data-canvas]'), {
        center: center, zoom: start ? 17 : 11,
        mapTypeId: 'roadmap', mapTypeControl: true, streetViewControl: false, fullscreenControl: false,
        clickableIcons: false, gestureHandling: 'greedy'
      });
      var marker = null;
      var ok = modal.querySelector('[data-ok]');
      function setPin(pos, zoom) {
        if (!marker) {
          marker = new google.maps.Marker({ position: pos, map: map, draggable: true });
          marker.addListener('dragend', function () { ok.disabled = false; });
        } else marker.setPosition(pos);
        if (zoom) { map.setZoom(zoom); map.panTo(pos); }
        ok.disabled = false; err.hidden = true;
      }
      if (start) setPin(center);
      map.addListener('click', function (ev) { setPin(ev.latLng); });

      modal.querySelector('[data-me]').addEventListener('click', function () {
        if (!navigator.geolocation) { err.textContent = 'Your browser does not support location.'; err.hidden = false; return; }
        err.hidden = true;
        navigator.geolocation.getCurrentPosition(function (p) { setPin({ lat: p.coords.latitude, lng: p.coords.longitude }, 17); },
          function (e) {
            var ua = navigator.userAgent || '';
            var ios = /iPhone|iPad|iPod/i.test(ua);
            var android = /Android/i.test(ua);
            var help;
            if (e && e.code === 1) {
              if (ios) help = 'Location access is blocked. Go to Settings > Privacy & Security > Location Services > your browser (Safari/Chrome) > While Using, then reload this page. Or simply tap the map to place the pin.';
              else if (android) help = 'Location access is blocked. Tap the lock icon next to the website address > Permissions > Location > Allow, make sure Location (GPS) is ON, then reload this page. Or simply tap the map to place the pin.';
              else help = 'Location access is blocked. Allow location for this website in your browser settings, then reload. Or simply tap the map to place the pin.';
            } else {
              help = 'Could not detect your location. Make sure Location (GPS) is ON, or simply tap the map to place the pin.';
            }
            err.textContent = help;
            err.hidden = false;
          },
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
      });

      var geocoder = new google.maps.Geocoder();
      function search() {
        var q = modal.querySelector('[data-q]').value.trim();
        if (!q) return;
        err.hidden = true;
        geocoder.geocode({ address: q, componentRestrictions: { country: 'AE' }, region: 'ae' }, function (res, status) {
          if (status === 'OK' && res && res[0]) {
            var loc = res[0].geometry.location;
            setPin(loc, 16);
          } else if (status === 'ZERO_RESULTS') {
            err.textContent = 'Nothing found. Try another name, or tap the map.'; err.hidden = false;
          } else {
            err.textContent = 'Search is not available now. Tap the map to place the pin.'; err.hidden = false;
          }
        });
      }
      modal.querySelector('[data-go]').addEventListener('click', search);
      modal.querySelector('[data-q]').addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); search(); } });

      ok.addEventListener('click', function () {
        if (!marker) return;
        var ll = marker.getPosition();
        ok.disabled = true; ok.textContent = 'Saving...';
        var url = urlFor(ll.lat(), ll.lng());
        save(url).then(function () { close(); done(url); }).catch(function () {
          ok.disabled = false; ok.textContent = 'Confirm this location';
          err.textContent = 'Could not save. Please try again.'; err.hidden = false;
        });
      });
    });
  }

  var boxRef = null;
  function render(box, url) {
    boxRef = box; pinned = !!url;
    root_el.classList.remove('of-pin-wait');
    box.classList.toggle('of-pin--need', !pinned);
    if (url) {
      box.innerHTML = '<p class="of-pin__ok">&#10003; Delivery location saved <a href="' + url + '" target="_blank" rel="noopener">View</a></p>' +
        '<button type="button" class="of-pin__btn" data-open>Change location</button>';
    } else {
      box.innerHTML = '<p class="of-pin__title">&#128205; Delivery location (required)</p>' +
        '<p class="of-pin__hint">Please drop a pin on the map at your home, villa or building. It is required so the delivery driver can find you.</p>' +
        '<button type="button" class="of-pin__btn of-pin__btn--fill" data-open>&#128205; Pin my delivery location</button>';
    }
    box.querySelector('[data-open]').addEventListener('click', function () {
      openMap(url, function (u) { render(box, u); if (wantCheckout) { wantCheckout = false; var cb = document.querySelector('[name="checkout"]'); if (cb) cb.click(); else location.href = root + 'checkout'; } });
    });
  }

  function place() {
    if (document.querySelector('[data-of-pin]')) return;
    var b = document.querySelector('main-cart [name="checkout"], #MainContent [name="checkout"], [name="checkout"]');
    if (!b || b.closest('cart-drawer')) return;
    var holder = b.parentElement;
    if (!holder || !holder.parentElement) return;
    var box = document.createElement('div');
    box.className = 'of-pin';
    box.setAttribute('data-of-pin', '');
    box.innerHTML = '<p class="of-pin__hint">Loading delivery location...</p>';
    holder.parentElement.insertBefore(box, holder);
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(box, (c.attributes && c.attributes[KEY]) || ''); })
      .catch(function () { render(box, ''); });
  }

  function needPin(e) {
    if (pinned) return;
    e.preventDefault(); e.stopImmediatePropagation();
    wantCheckout = true;
    if (boxRef) {
      boxRef.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var b = boxRef.querySelector('[data-open]'); if (b) b.click();
    }
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!c || c.closest('.of-map')) return;
    needPin(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') needPin(e);
  }, true);
  var t;
  function sched() { place(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sched); else sched();
  new MutationObserver(sched).observe(document.documentElement, { childList: true, subtree: true });
})();
